import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import CircularProgress from '@material-ui/core/CircularProgress';
import SortedLogo from '../../../shared/assets/sorted-logo-text.svg';

const FullPageCentre = styled.section`
	display: flex;
	height: 100vh;
	align-items: center;
	justify-content: center;
	padding: 10px;
`;

const SplashPanel = styled.div`
	flex: 0 1 525px;
	color: white;
	border-radius: 20px;
	box-shadow: 0 0 30px rgba(0, 0, 0, 0.15);
	min-height: 350px;
	display: flex;
	flex-direction: column;
	overflow: hidden;

	@media (min-width: 500px) {
		min-height: 550px;
	}
`;

const Header = styled.header`
	background-color: #323232;
	flex: 0 0 105px;
	display: flex;
	align-items: center;
	justify-content: center;

	svg {
		fill: white;
		height: 70px;
	}
`;

const Body = styled.div`
	color: #171717;
	padding: 20px;
	flex: 1 1 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	text-align: center;
`;

const Spinner = styled(CircularProgress)`
	margin-bottom: 50px;
`;

const SplashPage = ({ waiting, children }) => (
	<FullPageCentre>
		<SplashPanel>
			<Header>
				<SortedLogo />
			</Header>
			<Body>
				{waiting && <Spinner size={60} style={{ color: '#a4a5a8' }} />}
				{children}
			</Body>
		</SplashPanel>
	</FullPageCentre>
);

SplashPage.propTypes = {
	waiting: PropTypes.bool
};

SplashPage.defaultProps = {
	waiting: true
};

export default SplashPage;
